import { ComponentPublicInstance, VNode } from 'vue';

// Почему это осталось? Т.к. сейчас это используется, чтобы вывести только первого ребёнка,
// если будем выводить всех, то класс не будет попадать на этого ребёнка, в идеале на такие компоненты тупо не вешать классы
export function normalizeChildren(context: ComponentPublicInstance, slotProps = {}): VNode[] {
  return context.$slots.default?.(slotProps) || [];
}
